<div *ngIf="!isFormatValid && fallbackFormControl"
     class="input-container justify-center">
    <mat-form-field class="time-form-field fallback-time-field"
                    appearance="outline">
        <mat-label>{{ fallback.label }}</mat-label>
        <input class="text-contrast input-text"
               casZeroPadding
               matInput
               type="number"
               step="1"
               (focus)="fallbackFormControl.markAsTouched()"
               [disableControl]="isDisabled"
               [formControl]="fallbackFormControl" />
        <mat-error [ngClass]="textAlertClass"
                   *ngIf="fallbackFormControl && fallbackFormControl.invalid && fallbackFormControl.touched && fallbackFormControl.errors && (fallbackFormControl.errors.min || fallbackFormControl.errors.max)">
            ( {{ minValue }} - {{ maxValue }} )
        </mat-error>
    </mat-form-field>
</div>

<div *ngIf="isFormatValid"
     class="input-container justify-center">
    <div *ngFor="let timePart of filteredTimeParts; let i = index; let last = last;"
         [ngClass]="{'text-contrast': getTimePartClass(last, i)}">
        <mat-form-field class="time-form-field"
                        [class.fallback-time-field]="filteredTimeParts?.length == 1 ||possibilities[timePart].max > 100 || possibilities[timePart].min > 100"
                        appearance="outline">
            <mat-label>{{ possibilities[timePart].label }}</mat-label>
            <input class="text-contrast input-text"
                   casZeroPadding
                   matInput
                   (focus)="timePartFormControls[timePart].markAsTouched()"
                   [disableControl]="isDisabled"
                   [formControl]="timePartFormControls[timePart]"
                   step="1"
                   type="number" />
            <mat-error [ngClass]="textAlertClass"
                       class="customized-material-error"
                       *ngIf="timePartFormControls[timePart] &&  timePartFormControls[timePart].invalid && timePartFormControls[timePart].touched && timePartFormControls[timePart].errors && (timePartFormControls[timePart].errors.min || timePartFormControls[timePart].errors.max)">
                ( {{ possibilities[timePart].min }} - {{ possibilities[timePart].max }} )
            </mat-error>
        </mat-form-field>
        <span class="span-dots"
              *ngIf="getTimePartClass(last, i)">:</span>
    </div>

    <span class="meridiem-material-container"
          [ngClass]="{'disabled-meridiem': isDisabled}"
          *ngIf="hasMeridiem && meridiemFormControl">
        <div *ngFor="let option of meridiemOptions"
             [class.active]="meridiemFormControl.value === option.value"
             class="meridiem-material-pick"
             color="primary"
             (click)="isDisabled ? '' : updateMeridiem(option)">{{option.text}}</div>
    </span>
</div>

<mat-error class="mt-10"
           [ngClass]="textAlertClass"
           *ngIf="isFormatValid && !isValid">
    ( {{ formattedMin }} - {{ formattedMax }} )
</mat-error>